import { ChatBubble, HighlightOff } from "@mui/icons-material";
import { Button, createTheme, InputLabel, MenuItem, Select, SelectChangeEvent, ThemeProvider } from "@mui/material";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CheckoutForm } from "./CheckoutForm";
import React from "react"
import { StateManagerContext } from "./StateManagerContext";
import { UIConfigContext } from "./UIConfigContext";
import { FanboxStyling } from "./CSSUtilities";
import { ActionButton, ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";

const stripePromise = loadStripe('pk_test_51RLSh6IbbuxcPPQPfI5jjpVfViCPV1HbTBpTtf76jdS5G6BLmSwaabzjL5lC5uuBUI1sbCpksQ1NeIpOO3vwzU3l009nKVGPuJ')



const boostPackages: { label: string, boosts: number, price: number, productCode: string }[] = [
    { label: '10,000 boosts for $10', boosts: 10000, price: 10.0, productCode: 'Boosts10k' },
    { label: '25,000 boosts for $20', boosts: 25000, price: 20.0, productCode: 'Boosts25k' },
    { label: '50,000 boosts for $35', boosts: 50000, price: 35.0, productCode: 'Boosts50k' },
    { label: '100,000 boosts for $60', boosts: 100000, price: 60.0, productCode: 'Boosts100k' },
    { label: '250,000 boosts for $125', boosts: 250000, price: 125.0, productCode: 'Boosts250k' },

]

type PaymentIntentResponse = {
    error: boolean;
    message?: string;
    token?: string;
}


export type PurchaseBoostsProps = {
    height?: number;
    boostNeed?: number;
    backToHome : () => void
}

type PanelState = 'select' | 'checkout' | 'authorizing';

export const PurchaseBoosts = ({  height, boostNeed, backToHome }: PurchaseBoostsProps): JSX.Element => {

    const uiConfig = React.useContext(UIConfigContext);
    const stateManager = React.useContext(StateManagerContext);

    /*if(!stateManager.user().userInformation.signUpComplete)
    {
        uiConfig.showEventOverlay('signIn', {});
        backToHome();
    }*/

    
    const panelHeight = height === undefined ? (uiConfig.height - uiConfig.titleHeight) : height;

    const pageElements: JSX.Element[] = [];
    const [panelState, setPanelState] = React.useState<PanelState>('select');
    const [boostPackage, setBoostPackage] = React.useState<string>('');
    const [clientSecret, setClientSecret] = React.useState<string>('');

    //

    const theme = createTheme({
        palette: {
            mode: 'dark',
        },
    });

    const getPaymentIntent = async () => {
        const response = await fetch("/api/payments/createIntent", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ productCode: boostPackage, userId : stateManager.user().fanbox.id, accessToken : stateManager.user().fanbox.accessToken }),
        });
        const root = await response.json() as PaymentIntentResponse;

        if (!root.error) {
            setClientSecret(root.token ?? '');
        }

    }


    const _setBoostPackage = (value: string) => {
        boostPackages.forEach((row) => {
            if (value === row.label)
                setBoostPackage(row.productCode);
        })
    }

    /*const cancelPurchase = () => {
        setBoostPackage('');
        if(callback !== undefined)
            callback(false);
    }*/

    const proceedToPayment = () => {
        setPanelState('checkout');
    }

    const cancelPayment = () => {
        setPanelState('select');
    }

    /*const makePayment = () => {
        setPanelState('authorizing');
        const worker = async () => {
            const response = await fetch("/api/payments/succeeded", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ userId : stateManager.user().fanbox.id, token : clientSecret }),
            });
            const root = await response.json();
    
            callback(true);
    
        }
        worker();
    }*/

    if (panelState === 'select') {
        pageElements.push(<div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', marginTop: '20px', marginBottom: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 1, justifyContent: 'left', marginLeft: '30px' }}>
                {/*<ChatBubble sx={{ width: '18px' }} />*/}
                <span style={{ fontSize: '18px', color: 'white' }}>Buy Boost Package</span>
            </div>
            {/*<div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 2, justifyContent: 'right', marginRight: '30px' }}>
                <HighlightOff sx={{ height: '36px' }} onClick={() => { cancelPurchase(); }} />
            </div>*/}
        </div>);
        pageElements.push(<InputLabel id='boost-package-select-label'>Select your boost package</InputLabel>);
        pageElements.push(<Select
            labelId="boost-package-select-label"
            id="boost-package-select"
            label="Boost Packages"
            onChange={(ev: SelectChangeEvent) => { _setBoostPackage(ev.target.value) }}
            sx={{
                color: 'white',
                backgroundColor: '#303030',
                fontSize: uiConfig.fontBase,
                borderRadius: '8px',
                marginTop: '10px',
                marginLeft: '30px',
                marginRight: '30px',
                marginBottom: '10px',
            }}
        >
            {boostPackages.map((row) => {
                if (row.boosts > (boostNeed ??0))
                    return <MenuItem value={row.label}>{row.label}</MenuItem>
            })}

        </Select>);
        const buttonStyling : FanboxStyling = {
            width : 180,
            height : 48,
            color : {
                foreground : 'black',
                background : boostPackage === '' ? 'midGray' : 'green'
            },
            font : {
                size : 18,
                weight : 'regular'
            },
            boundary : {
                radius : 25
            }
        }
        const handler : ActionHandler = boostPackage === '' ? (_action)=> {return true} : (_action) => {proceedToPayment(); return true;}
        const action = CreateAction('onClick', boostPackage==='' ? [] : [{ permission : 'signedIn'}], handler);
        
        pageElements.push(<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', marginRight: '30px' }}>
            <ActionButton text={'Buy Now'} action={action} actionData={EmptyActionData} styling={buttonStyling} prompt={'left'}/>
        </div>);
    }
    else if (panelState === 'checkout') {
        if (clientSecret === '') {
            getPaymentIntent();
        }
        /*pageElements.push(<div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', marginTop: '20px', marginBottom: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 1, justifyContent: 'left', marginLeft: '30px' }}>
                <ChatBubble sx={{ width: '18px' }} />
                <span style={{ fontSize: '18px', color: 'white' }}>Checkout</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gridRow: 1, gridColumn: 2, justifyContent: 'right', marginRight: '30px' }}>
                <HighlightOff sx={{ height: '36px' }} onClick={() => { cancelPayment(); }} />
            </div>
        </div>);*/
        if (clientSecret !== '')
            pageElements.push(
                <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>
                    <CheckoutForm clientSecret={clientSecret}/>
                </Elements>
            );
        {/*pageElements.push(<Button onClick={() => { makePayment(); }}
            sx={{
                borderRadius: '25px',
                width: '92px',
                minWidth: '92px',
                maxWidth: '92px',
                height: '48px',
                minHeight: '48px',
                maxHeight: '48px',
                color: 'black',
                fontSize: '18px',
                fontWeight: 400,
                backgroundColor: '#92CA36'
            }} >Pay</Button>);*/}

    }
    else {
        pageElements.push(<span>Authorizing....</span>);
    }

    return (
        <div style={{
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            height: panelHeight + 'px',
            minHeight: panelHeight + 'px',
            maxHeight: panelHeight + 'px',
            backgroundColor: uiConfig.contolBackground,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <script async src='https://js.stripe.com/v3/' onLoad={() => { }} />
            <ThemeProvider theme={theme}>
                {pageElements}
            </ThemeProvider>
        </div>
    );
}